import { closeCaptionmeetingState } from '../models/meetModal';
import { meetActionTypes } from '../action/action';

const initialState = {
  closeCaptionText: [],
  showOriginalText: false,
  expandHide:false,
  ccBtns:false,
  currspeaker:"",
  fontSize: 16,
  ccStatus:false,
  captionStatus: false,
  captionBoolean:false,
  transcripts:[],
  isTask:false,
  isEditTask:false,
  taskName:"",
  keywords:[],
  highlights:[],
  oriTranscript:[],
  edittranscripts:[],
  ccLang:"en",
  speakerLang:"en",
  audioLang:"en",
  tasklist:[],
  recogStatus:"",
  files:[],
  editautomatedmins:[],
  transcriptOpen:false,
  scrollTrans:false,
  searchVisible:false,
  search:"",
  filterByName:[],
  byHighlight:false,
  applyFilter:false,
  transLoader:true,
  recordTranscript:[],
  recordId:""
};


const closeCaption = (state: closeCaptionmeetingState = initialState, action: any) => {

  switch (action.type) {
  case meetActionTypes.CC_STATUS:
    return {
      ...state, captionStatus: action.payload.captionStatus,captionBoolean:action.payload.captionBoolean,transcriptOpen:action.payload.transcriptOpen
    };
  case meetActionTypes.CLOSE_CAPTION:
    return {
      ...state, closeCaptionText: action.payload.closeCaptionText, fontSize: action.payload.fontSize,
      showOriginalText:action.payload.showOriginalText,ccBtns:action.payload.ccBtns
    };

  // case meetActionTypes.CLOSE_CAPTION:
  //   return {
  //     ...state, closeCaptionData: action.payload.closeCaptionData, ccSpeaker: action.payload.ccSpeaker,
  //     speakerName: action.payload.speakerName,ccBtns:action.payload.ccBtns
  //   };
    
  case meetActionTypes.TRANSCRIPTS_LIST:
    return {
      ...state, transcripts: action.payload.transcripts,oriTranscript:action.payload.oriTranscript,scrollTrans:action.payload.scrollTrans,transLoader:action.payload.transLoader
    };
  case meetActionTypes.TRANSCRIPTS_LIST_EDIT:
    return {
      ...state, edittranscripts: action.payload.edittranscripts
    };
  case meetActionTypes.AUDIO_LANG:
    return {
      ...state, audioLang: action.payload.audioLang
    };
  case meetActionTypes.CC_LANG:
    return {
      ...state, ccLang: action.payload.ccLang,expandHide:action.payload.expandHide
    };
  case meetActionTypes.SPEAKER_LANG:
    return {
      ...state, speakerLang: action.payload.speakerLang
    };
  case meetActionTypes.TRANSCRIPTS_FILTER:
    return {
      ...state, searchVisible: action.payload.searchVisible,search:action.payload.search,filterByName:action.payload.filterByName,byHighlight:action.payload.byHighlight,applyFilter:action.payload.applyFilter
    };
  case meetActionTypes.RECORD_TRANSCRIPT:
    return {
    ...state, recordTranscript: action.payload.recordTranscript,recordId:action.payload.recordId
    };
    
  default:
    return state;
  };
};

export default closeCaption;
